import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FieldWrapper,
  FormlyFieldConfig,
  FormlyFieldProps,
} from '@ngx-formly/core';
import { Button } from 'primeng/button';
import { Divider } from 'primeng/divider';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';

export interface EditableFieldProps extends FormlyFieldProps {
  buttonLabel: string;
  buttonSeverity?: typeof Button.prototype.severity;
  onClick: any;
  blur?: any;
  isDetailPage?: boolean;
}

@Component({
  selector: 'formly-wrapper-primeng-editable',
  standalone: true,
  imports: [CommonModule, ...FORM_IMPORTS, Button, Divider],
  template: ` <div
    class="{{
      'editable-field ' +
        (field.props?.isDetailPage ? 'pointer-events-none' : '')
    }}"
    (click)="onClick()"
  >
    <div class="-mb-4" (click)="onClick()">
      <ng-container #fieldComponent></ng-container>
    </div>
    <div class="flex h-[var(--p-button-icon-only-width)]">
      <p-divider
        [class]="field.props?.isDetailPage ? 'w-full justify-self-center' : ''"
      ></p-divider>
      @if (formControl.disabled && !field.props?.isDetailPage) {
        <p-button
          icon="fa-solid fa-pen-to-square"
          [text]="true"
          (onClick)="onClick($event)"
          [hidden]=""
        />
      }
    </div>
  </div>`,
  styles: `
    :host ::ng-deep {
      .editable-field {
        .p-divider-horizontal:before {
          border-block-start: 2px solid var(--p-primary-color) !important;
        }

        .p-inputtext:disabled {
          background-color: transparent !important;
          text-align: center !important;
          font-weight: bold !important;
        }

        .p-inputtext {
          border: none !important;
          box-shadow: none !important;
          padding-block: 0 !important;
          padding-right: var(--p-button-icon-only-width) !important;
        }
      }
    }
  `,
})
export class EditableFormlyWrapper extends FieldWrapper<
  FormlyFieldConfig<EditableFieldProps>
> {
  constructor() {
    super();
  }
  ngOnInit() {
    this.formControl.disable();
    this.field.props!.blur = () => {
      this.formControl.disable();
    };
  }

  onClick(event?: MouseEvent) {
    this.formControl.enable();
    this.field.focus = true;
  }
}
